import { Component, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-modal-solicitacao',
  templateUrl: './modal-solicitacao.component.html',
  styleUrls: ['./modal-solicitacao.component.scss']
})
export class ModalSolicitacaoComponent  {

  modalRef?: BsModalRef;
  solicitacao: any;

  @ViewChild('modal') modal: TemplateRef<any>;

  constructor(
    private modalService: BsModalService,
  ) { }

  openModal(solicitacao) {
    this.solicitacao = solicitacao;
    this.modalRef = this.modalService.show(this.modal);
  }

  closeModal() {
    this.solicitacao = {};
    this.modalRef?.hide();
  }

}
